export function clickActs(controls, playSlot) {
  return controls?.[playSlot]?.disabled === false;
}
